import { Field } from '@components/Select/style'
import * as React from 'react'

import { SwitchProps } from './interface'
import { Input, Slider, SpinnerBox, StyledSpinner, SwitchBox } from './style'

const Switch = ({
  name,
  checked,
  onChange,
  className,
  loading,
  disabled,
  size,
  label,
  defaultChecked,
  customLabel,
}: SwitchProps) => {
  const body = (
    <SwitchBox htmlFor={name} checked={checked} className={className} loading={loading} disabled={disabled} size={size}>
      <Input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        disabled={disabled}
        defaultChecked={defaultChecked}
        onChange={onChange}
        value={`${checked}`}
      />
      {loading ? (
        <Slider hasEvent={typeof onChange === 'function'}>
          <SpinnerBox>
            <StyledSpinner size="sm" />
          </SpinnerBox>
        </Slider>
      ) : (
        <Slider hasEvent={typeof onChange === 'function'} />
      )}
    </SwitchBox>
  )

  if (customLabel) {
    return (
      <>
        <Field disableMargin>
          <>
            {customLabel}
            {body}
          </>
        </Field>
      </>
    )
  }

  return label ? (
    <Field label={label} disableMargin>
      {body}
    </Field>
  ) : (
    body
  )
}

export default React.memo(Switch)
